import React from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider } from 'antd';
import Router from '@/router';
import ErrorBoundary from '@/components/ErrorBoundary';
import { theme } from '@/utils/theme';
import JalaliListener from '@/components/DatePicker/JalaliListener';
import { FilterProvider } from '@/providers/FilterContext';
import { AuthProvider } from '@/providers/AuthContext';
import useLanguage from '@/hooks/useLanguage';
import useConsole from '@/hooks/useConsole';
import Loading from '@/components/Loading';
import ReactQueryProvider from '@/providers/ReactQueryProvider';

const App: React.FC = () => {
  useConsole();
  const { isFa, direction, currentLocal } = useLanguage();
  return (
    <ErrorBoundary>
      <React.Suspense fallback={<Loading />}>
        <ReactQueryProvider>
          <FilterProvider>
            <AuthProvider>
              <ConfigProvider
                direction={direction}
                theme={theme}
                locale={currentLocal}
              >
                <Router />
                {isFa && <JalaliListener />}
                <ReactQueryDevtools initialIsOpen={false} />
              </ConfigProvider>
            </AuthProvider>
          </FilterProvider>
        </ReactQueryProvider>
      </React.Suspense>
    </ErrorBoundary>
  );
};

export default App;
